import { FC } from 'react';

import { DateTime } from 'luxon';

import { SelectedInactiveCompanyService } from '@hooks_iqfu/dashboard/useCompanyData';

import { CompanyDetailType } from '@type-def_iqfu/CompanyType';

import { DateOutputFormat } from '@constants_iqfu';

import styles from './RightColumnMemberShipStatus.module.scss';

type Props = {
  companyData: CompanyDetailType;
};

const RightColumnMemberShipStatus: FC<Props> = ({ companyData }) => {
  const isAffiliated = (key: SelectedInactiveCompanyService) => companyData?.company_services.includes(key);
  return (
    <div className={styles.right_column_container_item}>
      <div className={styles.right_column_container_membership_status_area}>
        <p className={styles.right_column_container_membership_status_title}>加盟状況</p>
      </div>
      <div className={styles.right_column_container_membership_status_wrapper}>
        <div className={styles.right_column_container_value}>
          <p className={styles.right_column_container_value_label}>イクラ不動産加盟日</p>
          {companyData?.iqfu.has_iqfu && companyData?.iqfu.start_date
            ? DateTime.fromISO(companyData?.iqfu.start_date).toFormat(DateOutputFormat)
            : '非加盟'}
        </div>
        <div className={styles.right_column_container_value}>
          <p className={styles.right_column_container_value_label}>イクラウド加盟日</p>
          {companyData?.cloud.has_cloud && companyData?.cloud.start_date
            ? DateTime.fromISO(companyData?.cloud.start_date).toFormat(DateOutputFormat)
            : '非加盟'}
        </div>
        <div className={styles.right_column_container_value}>
          <p className={styles.right_column_container_value_label}>Pro加盟</p>
          {isAffiliated('pro') ? '加盟' : '非加盟'}
        </div>
        <div className={styles.right_column_container_value}>
          <p className={styles.right_column_container_value_label}>埋め込み地図加盟</p>
          {isAffiliated('embed_map') ? '加盟' : '非加盟'}
        </div>
        <div className={styles.right_column_container_value}>
          <p className={styles.right_column_container_value_label}>売却LP加盟</p>
          {isAffiliated('selling_page') ? '加盟' : '非加盟'}
        </div>
        <div className={styles.right_column_container_value}>
          <p className={styles.right_column_container_value_label}>AI査定加盟</p>
          {isAffiliated('ai_appraisal') ? '加盟' : '非加盟'}
        </div>
        <div className={styles.right_column_container_value}>
          <p className={styles.right_column_container_value_label}>来店予約加盟</p>
          {isAffiliated('visit_reservation') ? '加盟' : '非加盟'}
        </div>
        <div className={styles.right_column_container_value}>
          <p className={styles.right_column_container_value_label}>口コミ連動加盟</p>
          {isAffiliated('user_voice') ? '加盟' : '非加盟'}
        </div>
      </div>
    </div>
  );
};

export default RightColumnMemberShipStatus;
